import React from 'react';
import { RecipeWithStats } from '@/services/recipe/recipeStatsService';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import RecipeImage from '@/components/recipe/RecipeImage';
import RecipeIcon from '@/components/common/RecipeIcon';

interface CompactRecipeImageSelectionCardProps {
  recipe: RecipeWithStats;
  onSelect: () => void;
  isSubmitting: boolean;
}

const CompactRecipeImageSelectionCard: React.FC<CompactRecipeImageSelectionCardProps> = ({ 
  recipe, 
  onSelect, 
  isSubmitting 
}) => {
  const handleClick = () => {
    if (!isSubmitting) {
      onSelect();
    }
  };

  return (
    <Card 
      className="h-full flex flex-col border-golden-light bg-card shadow-sm hover:shadow-md transition-shadow duration-200 hover:border-sage/30 overflow-hidden"
    >
      <div className="relative">
        <RecipeImage 
          recipe={recipe}
          size="sm"
          compact={true}
          className="w-full rounded-none"
        />
        {recipe.isQuickRecipe && (
          <div className="absolute top-1 left-1 bg-emerald-100 rounded-full p-1">
            <RecipeIcon type="quick-recipe" size={8} className="text-emerald-700" />
          </div>
        )}
        {/* Selection overlay when submitting */}
        {isSubmitting && (
          <div className="absolute inset-0 bg-sage/20 flex items-center justify-center">
            <div className="text-xs text-sage font-medium bg-cream px-2 py-1 rounded">
              Selecting...
            </div>
          </div>
        )}
      </div>
      <CardContent className="flex-1 p-2">
        <h3 className="text-sm font-semibold text-charcoal line-clamp-2 leading-tight">
          {recipe.title}
        </h3>
      </CardContent>
      <CardFooter className="p-2 pt-0">
        <Button 
          onClick={onSelect}
          disabled={isSubmitting}
          size="sm" 
          className="w-full h-8 text-xs font-inter bg-sage text-cream hover:bg-sage/90"
        >
          {isSubmitting ? 'Selecting...' : 'Select Recipe'}
        </Button>
      </CardFooter>
    </Card>
  );
};

export default CompactRecipeImageSelectionCard;